import { WPFMessageType } from '@/enums';
import type { ScreenSaverInfo } from '@/services/dto';
import type { DbResponse } from '@/stores';
import type { CacheScreenSaverInfo } from '@/types';
import { dbManager } from '@/utils';

export class ScreenSaverManager {
    static needsDownload(apiItem: ScreenSaverInfo, cachedItem?: CacheScreenSaverInfo): boolean {
        if (!cachedItem) {
            return true;
        }

        if (apiItem.updateDate && apiItem.updateDate != cachedItem.updateDate) {
            return true;
        }

        if (apiItem.createDate != cachedItem.originalData.createDate) {
            return true;
        }

        if(!cachedItem.downloadDate) {
            return true;
        }

        return false;
    }

    static async downloadFiles(downloadItems: Array<{ id: string; fileUrl: string }>) {
        if (downloadItems.length > 0 && window.chrome && window.chrome.webview) {
            const message = {
                type: WPFMessageType.DownloadImages,
                items: downloadItems,
            };
            window.chrome.webview.postMessage(message);
        }
    }

    static async processScreenSaverItems(apiItems: ScreenSaverInfo[]): Promise<CacheScreenSaverInfo[]> {
        const cachedData = await dbManager.get<DbResponse>('config', 'systemConfig');
        const cachedScreensaver = cachedData?.value?.ui?.screenSaver || [];
        const processedItems: CacheScreenSaverInfo[] = [];
        const downloadItems: Array<{ id: string; fileUrl: string }> = [];

        for (const apiItem of apiItems) {
            const existingCached = cachedScreensaver.find((cached: CacheScreenSaverInfo) => cached.id === apiItem.id);
            const needsDownload = this.needsDownload(apiItem, existingCached);

            if (needsDownload) {
                downloadItems.push(apiItem);

                const cachedItem: CacheScreenSaverInfo = {
                    id: apiItem.id,
                    originalData: apiItem,
                    localPath: null,
                    downloadDate: null,
                    updateDate: apiItem.updateDate,
                };

                processedItems.push(cachedItem);
            } else {
                if (existingCached) {
                    processedItems.push(existingCached);
                }
            }
        }

        // Batch download all required files
        if (downloadItems.length > 0) {
            await this.downloadFiles(downloadItems);
        }

        return processedItems;
    }
}
